import { SearchIcon } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";

const LeadDropdown = ({
  leadOptions = [],
  searchLead,
  setSearchLead,
  onSelect,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (lead) => {
    setSearchLead(lead.name);
    onSelect(lead);
    setShowDropdown(false);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <div
        className="w-full border border-gray-300 rounded-md px-3 py-3 text-sm cursor-pointer bg-white"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        {searchLead || "Search Lead"}
      </div>

      {showDropdown && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-md">
          <div className="relative p-2">
            <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              value={searchLead}
              onChange={(e) => setSearchLead(e.target.value)}
              placeholder="Search Lead"
              className="w-full pl-8 pr-3 py-2 border border-gray-200 rounded-full text-sm focus:outline-none "
              autoFocus
            />
          </div>

          {/* Dropdown List */}
          <ul className="max-h-48 overflow-auto">
            {leadOptions.length > 0 ? (
              leadOptions.map((lead) => (
                <li
                  key={lead.id}
                  onClick={() => handleSelect(lead)}
                  className="px-4 py-2 hover:bg-green-100 cursor-pointer text-sm"
                >
                  <div className="flex items-start justify-between">
                    <div className=""> 
                      <div title={lead?.name} className="font-medium w-36  truncate text-gray-800">
                        {lead.name}
                      </div>
                      <div className="text-gray-500 text-xs">
                        {lead?.phoneNumber}
                      </div>
                    </div>
                    <div className="bg-green-50 border text-xs text-nowrap border-customGreen rounded-full px-2 w-28  text-customGreen text-center">{lead?.status}</div>
                  </div>
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-sm text-gray-400">
                No leads found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LeadDropdown;
